import { render, staticRenderFns } from "./Professionnalisation2.vue?vue&type=template&id=1df36d36"
import script from "./Professionnalisation2.vue?vue&type=script&lang=js"
export * from "./Professionnalisation2.vue?vue&type=script&lang=js"
import style0 from "./Professionnalisation2.vue?vue&type=style&index=0&id=1df36d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports